import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { toast } from 'react-toastify';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner
} from 'reactstrap';
import OtherAssetsAttachmentsService from "src/modules/data-protection/apis/OtherAssetsAttachmentsService";

const DeleteAttachmentModal = ({ 
    t,
    isOpen, 
    toggle, 
    onComplete, 
    attachment
}) => {
    const {
        mutate: deleteDocumentMutation,
        isLoading: deletingAttachmentInProcess
    } = useMutation({
        mutationFn: async () => {
            const service = OtherAssetsAttachmentsService.getInstance();
            return await service.deleteAttachment(attachment.id);
        },
        onSuccess: () => {
            toast(t("Attachment deleted successfully."), {
                type: "success"
            });
            onComplete && onComplete();
            toggle();
        },
        onError: () => {
            toast(t("An error occurred while deleting the attachment."), {
                type: "error"
            });
        }
    });

    return (
        <Modal 
            isOpen={isOpen} 
            toggle={toggle}
        >
            <ModalHeader 
                toggle={toggle}
            >
                {t('Confirm Attachment Deletion')}
            </ModalHeader>
            <ModalBody>
                {t('Are you sure you want to delete')}{" "}
                <strong>{attachment?.title || attachment?.originName}</strong>?
                <br />
                {t('This action cannot be undone.')}
            </ModalBody>
            <ModalFooter>
                <Button 
                    color="danger" 
                    onClick={deleteDocumentMutation}
                    disabled={deletingAttachmentInProcess}
                >
                    {deletingAttachmentInProcess && (
                        <Spinner 
                            size='sm'
                            color='danger'
                            className='me-1'
                        />
                    )}
                    {t('Delete')}
                </Button>
                <Button 
                    color="secondary" 
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    DeleteAttachmentModal
);